import ShareMsgBase from './A_G.ShareMsgBase';

class MsgAdsFallback extends ShareMsgBase {
  /**
   * The message that gets sent when you send a message to a friend to watch an ad
   * @param {string} user1
   * @param {function} onAllImagesReadyCallback
   */
  constructor(user1, onAllImagesReadyCallback = null) {
    super(2, onAllImagesReadyCallback);

    this.bg = this._addExtImage(0, 0, 'img/Msg_Ads_Fallback.png', 0, null, null);

    this.thanksforyourhelp = this.add(new G.Text(336, 50,
      OMT.language.getText('Thank you for helping me.'), {
        style: 'msg-white',
        fontSize: '40px',
      }, 0.5, 420));
    this.avatar1 = this._addExtImage(50, 139, user1, 0, 175, null);
  }
}

// create global references
G.MsgAdsFallback = MsgAdsFallback;
